var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1203.47 512",
    style: {
      enableBackground: "new 0 0 1203.47 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;fill:#DDFF05;}\r\n\t.st1{fill:#161616;}\r\n\t.st2{display:none;}\r\n\t.st3{display:inline;}\r\n\t.st4{fill:#1D1D1B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_18"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 238.04,
    cy: 263.59,
    rx: 157.41,
    ry: 94.82
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M405,186.15h-58.35c-4.75,0-8.6,3.85-8.6,8.6v0c0,4.75,3.85,8.6,8.6,8.6H405c4.75,0,8.6-3.85,8.6-8.6v0 C413.6,190,409.75,186.15,405,186.15z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M405,323.82h-58.35c-4.75,0-8.6,3.85-8.6,8.6v0c0,4.75,3.85,8.6,8.6,8.6H405c4.75,0,8.6-3.85,8.6-8.6v0 C413.6,327.67,409.75,323.82,405,323.82z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M623.11,229.25c-2.2,7.44-9.16,12.07-18.14,12.07c-12.21,0-20.1-9.19-20.1-23.42 c0-14.39,7.7-23.33,20.1-23.33c8.86,0,15.5,4.58,17.76,12.25l0.16,0.56h14.31l-0.14-0.9c-2.43-15.27-14.92-25.14-31.8-25.14 c-20.73,0-34.66,14.73-34.66,36.66c0,22.21,13.38,36.56,34.09,36.56c16.76,0,29.85-10.02,32.56-24.94l0.17-0.92h-14.14 L623.11,229.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M664.69,237.62l-11.52-32.66h-13.93l19.19,49.66l-1.23,3.24c-1.85,5.1-4.37,6.04-8.66,6.04h-7.71v11.06 l0.58,0.15c2.77,0.72,5.66,1.07,8.83,1.07c8.09,0,13.29-3.96,16.86-12.83l23.4-58.39h-13.65L664.69,237.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M723.89,203.44c-6.41,0-12.17,2.51-15.64,6.67v-28.88h-13.14v72.17h12.21l0.59-5.72 c3.19,4.4,8.71,6.96,15.22,6.96c13.81,0,23.08-10.12,23.08-25.17C746.21,213.9,737.24,203.44,723.89,203.44z M720.76,215.44 c7.43,0,12.22,5.32,12.22,13.55c0,8.18-4.8,13.46-12.22,13.46c-7.43,0-12.41-5.41-12.41-13.46 C708.34,220.89,713.33,215.44,720.76,215.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M786.92,237.22c-1.22,4.11-5.17,6.37-11.12,6.37c-7.08,0-11.02-3.56-12.03-10.88l35.21-0.1v-4.29 c0-15.06-9.32-24.79-23.75-24.79c-14.21,0-24.13,10.55-24.13,25.65c0,14.99,10.08,25.46,24.51,25.46 c12.67,0,21.47-6.37,23.54-17.05l0.18-0.93h-12.25L786.92,237.22z M764.12,223.76c1.28-6.08,5.04-9.17,11.21-9.17 c6.16,0,10.24,3.57,10.59,9.17H764.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M819.86,229.85c0-8.25,4.54-12.79,12.79-12.79h5.05v-12.11l-0.59-0.15c-1.88-0.47-3.56-0.69-5.31-0.69 c-5.3,0-9.62,2.14-12.19,5.96l-0.49-5.01h-12.4v48.35h13.14V229.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M599.66,273.34h-25.08v70.94h25.74c20.46,0,34.76-14.53,34.76-35.33 C635.08,287.98,620.51,273.34,599.66,273.34z M588.29,286.1h10.23c13.9,0,22.19,8.54,22.19,22.85c0,14.13-8.05,22.57-21.53,22.57 h-10.9V286.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M662.88,328.5l-11.52-32.66h-13.93l19.19,49.66l-1.23,3.24c-1.85,5.1-4.37,6.04-8.66,6.04h-7.71v11.06 l0.58,0.15c2.78,0.72,5.67,1.07,8.83,1.07c8.09,0,13.29-3.96,16.86-12.83l23.4-58.39h-13.65L662.88,328.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M720.76,294.41c-5.99,0-11.27,2.32-14.52,6.28l-0.76-4.85h-12.17v48.44h13.14v-26.02 c0-7.25,4.1-11.75,10.71-11.75c5.86,0,9.09,3.87,9.09,10.9v26.88h13.14v-29.63C739.38,301.78,732.59,294.41,720.76,294.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M770.2,294.41c-13.07,0-21.85,7.06-21.85,17.58v0.78h11.43v-0.78c0-6.09,6.17-7,9.85-7 c5.99,0,8.9,2.66,8.9,8.14v0.32l-13.33,0.99c-11.49,0.89-18.09,6.6-18.09,15.68c0,9.35,6.6,15.4,16.82,15.4 c6.55,0,12.31-2.54,15.18-6.5l0.65,5.26h11.62v-29.25C791.39,301.92,783.67,294.41,770.2,294.41z M778.63,322.89v1.63 c0,6.7-4.07,10.71-10.9,10.71c-4.9,0-7.29-1.83-7.29-5.58c0-2.42,1.05-5.3,9.25-6.06L778.63,322.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M856.95,294.41c-6.66,0-12.15,2.95-15,7.98c-2.92-5.16-8.02-7.98-14.52-7.98c-5.64,0-10.42,2.07-13.41,5.73 l-0.74-4.31h-12.07v48.44h13.14v-27.35c0-6.53,3.43-10.42,9.19-10.42c5.24,0,8.24,3.38,8.24,9.28v28.49h13.14v-27.35 c0-6.58,3.4-10.52,9.09-10.52c5.3,0,8.33,3.45,8.33,9.47v28.4h13.04v-31.43C875.38,301.3,868.49,294.41,856.95,294.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M891.78,272.49c-4.43,0-7.9,3.39-7.9,7.71c0,4.37,3.47,7.8,7.9,7.8c4.25,0,7.71-3.5,7.71-7.8 C899.49,275.94,896.03,272.49,891.78,272.49z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 885.21,
    y: 295.83,
    className: "st1",
    width: 13.14,
    height: 48.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M940.66,326.14c-1.13,4.69-4.9,7.38-10.35,7.38c-6.9,0-11.18-5.19-11.18-13.55c0-8.29,4.54-13.65,11.56-13.65 c5.3,0,8.75,2.59,9.97,7.48l0.15,0.59h13.06l-0.09-0.86c-1.29-11.79-10.31-19.11-23.55-19.11c-14.26,0-24.22,10.51-24.22,25.55 c0,15.28,9.77,25.55,24.32,25.55c12.6,0,22.06-7.67,23.55-19.09l0.11-0.88H940.8L940.66,326.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M985.16,315.97l-8.45-1.99c-3.68-0.88-5.48-2.37-5.48-4.56c0-3.06,2.35-4.82,6.43-4.82 c3.94,0,6.35,2.16,6.43,5.79l0.02,0.76h12.56l-0.01-0.79c-0.1-9.54-7.54-15.96-18.53-15.96c-11.59,0-19.38,6.22-19.38,15.49 c0,7.63,4.17,12.13,13.13,14.14l8.45,1.99c4.22,0.96,4.8,2.62,4.8,4.27c0,3.06-2.76,4.82-7.57,4.82c-4.79,0-7.58-2.14-7.67-5.88 l-0.02-0.76h-12.55v0.78c0,9.72,7.98,16.25,19.86,16.25c12.22,0,20.43-6.49,20.43-16.15 C997.62,322.08,993.78,317.95,985.16,315.97z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M433.6,289.4h-86.96c-4.75,0-8.6,3.85-8.6,8.6l0,0c0,4.75,3.85,8.6,8.6,8.6h86.96c4.75,0,8.6-3.85,8.6-8.6l0,0 C442.21,293.25,438.36,289.4,433.6,289.4z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M433.6,220.57h-86.96c-4.75,0-8.6,3.85-8.6,8.6v0c0,4.75,3.85,8.6,8.6,8.6h86.96c4.75,0,8.6-3.85,8.6-8.6v0 C442.21,224.42,438.36,220.57,433.6,220.57z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M462.75,254.98h-116.1c-4.75,0-8.6,3.85-8.6,8.6v0c0,4.75,3.85,8.6,8.6,8.6h116.1c4.75,0,8.6-3.85,8.6-8.6v0 C471.35,258.84,467.5,254.98,462.75,254.98z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M270.16,341.03l21.03,0c4.75,0,8.6-3.85,8.6-8.6l0,0c0-4.75-3.85-8.6-8.6-8.6h-21.03c-4.75,0-8.6,3.85-8.6,8.6 v0C261.55,337.18,265.4,341.03,270.16,341.03z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M270.16,203.36l21.03,0c4.75,0,8.6-3.85,8.6-8.6v0c0-4.75-3.85-8.6-8.6-8.6l-21.03,0c-4.75,0-8.6,3.85-8.6,8.6 v0C261.55,199.5,265.4,203.36,270.16,203.36z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.38,237.77l21.03,0c4.75,0,8.6-3.85,8.6-8.6v0c0-4.75-3.85-8.6-8.6-8.6l-21.03,0c-4.75,0-8.6,3.85-8.6,8.6 v0C227.77,233.92,231.62,237.77,236.38,237.77z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.38,306.61l21.03,0c4.75,0,8.6-3.85,8.6-8.6l0,0c0-4.75-3.85-8.6-8.6-8.6h-21.03c-4.75,0-8.6,3.85-8.6,8.6 v0C227.77,302.76,231.62,306.61,236.38,306.61z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M201.96,272.19h21.03c4.75,0,8.6-3.85,8.6-8.6l0,0c0-4.75-3.85-8.6-8.6-8.6l-21.03,0c-4.75,0-8.6,3.85-8.6,8.6 l0,0C193.35,268.34,197.21,272.19,201.96,272.19z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_6"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_5"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_4"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_3",
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_17",
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "534.09,217.91 519.95,217.91 519.95,229.82 493.29,229.82 493.29,183.36 519.95,183.36  519.95,195.39 534.09,195.39 534.09,180.03 525.2,171.58 488.15,171.58 479.15,180.03 479.15,233.16 488.15,241.71  525.2,241.71 534.09,233.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "598.12,187.44 584.53,187.44 584.53,227.44 562.13,227.44 562.13,187.44 548.53,187.44  548.53,229.74 557.52,238.19 584.53,238.19 584.53,252.62 562.02,252.62 562.02,246.09 549.07,246.09 549.07,254.61  558.07,263.06 589.13,263.06 598.12,254.61  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M728.26,224.12h-13.05v7.56h-21.63v-15.37h34.69v-20.34l-8.89-8.55H689.2l-8.89,8.55v37.18l8.89,8.55h30.18 l8.89-8.55V224.12z M693.58,197.46h21.63v13.4h-21.63V197.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M536.38,281.21l-12.16-11.45H481v70.13h43.22l12.16-11.55V281.21z M522.24,323.91l-4.31,4.09h-22.78v-46.46 h22.79l4.3,4.21V323.91z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "598.12,285.61 584.53,285.61 584.53,325.62 562.13,325.62 562.13,285.61 548.53,285.61  548.53,327.92 557.52,336.37 584.53,336.37 584.53,350.8 562.02,350.8 562.02,344.27 549.07,344.27 549.07,352.79  558.07,361.24 589.13,361.24 598.12,352.79  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M727.94,339.89v-45.72l-9-8.55h-29.2l-9,8.55v7.69h12.73v-5.49h21.42v13.61h-25.91l-9,8.55v12.82l9,8.55 h19.7l8.17-7.88v7.88H727.94z M714.88,326.44l-4.57,3.74h-17.28v-14.23h21.85V326.44z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 844.37,
    y: 264.89,
    className: "st4",
    width: 13.93,
    height: 10.44
  }), /*#__PURE__*/React.createElement("rect", {
    x: 844.48,
    y: 285.61,
    className: "st4",
    width: 13.6,
    height: 54.27
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "921.23,319.4 908.18,319.4 908.18,328.42 887.42,328.42 887.42,296.98 908.18,296.98 908.18,306  921.23,306 921.23,294.16 912.34,285.61 883.04,285.61 874.14,294.16 874.14,331.34 883.04,339.89 912.34,339.89 921.23,331.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "983.41,318.8 948.83,300.98 948.83,294.6 969.7,294.6 969.7,301.65 982.43,301.65 982.43,294.16  973.43,285.61 944.34,285.61 935.45,294.16 935.45,306.7 969.92,324.53 969.92,330.9 947.74,330.9 947.74,324.48 935.12,324.48  935.12,331.34 944.12,339.89 974.41,339.89 983.41,331.34  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M664.78,195.99l-9-8.55H629v-20.73h-13.6v75h40.38l9-8.55V195.99z M651.07,229.93h-17.4l-4.67-3.96v-27.17 h22.07V229.93z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "828.18,339.89 828.18,294.16 819.18,285.61 744.12,285.61 744.12,339.89 757.72,339.89  757.72,301.36 762.38,297.4 779.57,297.4 779.57,339.89 793.17,339.89 793.17,297.4 814.58,297.4 814.58,339.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "664.78,339.89 664.78,294.16 655.78,285.61 614.96,285.61 614.96,339.89 628.56,339.89  628.56,301.36 633.23,297.4 651.18,297.4 651.18,339.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "776.7,199.63 776.7,187.44 743.57,187.44 743.57,241.71 757.17,241.71 757.17,204.23 762.38,199.63  "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ec6460f4b7cddd537ffcc087716f46ae.svg";
export { ForwardRef as ReactComponent };